export function getFormModalPayload(values) {
  return values
}
